module.exports = __webpack_public_path__ + "img/pattern_vue.d203753c.png";